import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import BlueLogo from "../../assets/bluelogo.svg";
import SigLogo from "../../assets/sig-logo.svg";
import { determineIfTheLanguageIsEnglish, determineLocale, useLocale } from "../../contexts/LocaleContext";
import { getComplianceUrls } from "./footerLinkUtil";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { RootState } from "../../reducers";
import { PCE } from "../../app-consts/appConstants";
import { isCanadianLocale } from "../../utils";

const Footer = ({ hasAllstateBrandFooter, isFooterBrandingEnabled, isRescueTrackerStandalone }) => {
  const location = useLocation();
  const getTranslatedText = useLocale();
  const locale = determineLocale();
  const isAllstateCanadaCompliance = useSelector(
    (state: RootState) => state.partnerDetails?.partnerDetails?.allstateCanadaCompliance
  );
  const isAllstateCanadaPartner = location.pathname.includes(PCE);
  const isCanadianFooter = isAllstateCanadaPartner && isCanadianLocale(locale);

  const complianceURLs = getComplianceUrls(isAllstateCanadaCompliance);
  const showNoticeAtCollection =
    !isRescueTrackerStandalone || determineIfTheLanguageIsEnglish(window.location.pathname, window.location.search);

  const links = (
    <>
      <a className="c-link" href={complianceURLs.privacy}>
        {getTranslatedText(TRANSLATION_CONSTANTS.PRIVACY_POLICY)}
      </a>{" "}
      |
      {!!complianceURLs.sms_terms_condition ? (
        <>
          <a className="c-link" href={getTranslatedText(TRANSLATION_CONSTANTS.SMS_TERMS_CONDITION_LINK)}>
            {" "}
            {getTranslatedText(TRANSLATION_CONSTANTS.SMS_TERMS_CONDITION)}
          </a>{" "}
          |{" "}
        </>
      ) : (
        <></>
      )}
      {showNoticeAtCollection && !!complianceURLs.notice_at_collection ? (
        <>
          <a className="c-link" href={complianceURLs.notice_at_collection}>
            {" "}
            {getTranslatedText(TRANSLATION_CONSTANTS.NOTICE_AT_COLLECTION)}
          </a>{" "}
          |{" "}
        </>
      ) : null}
      <a className="c-link" href={complianceURLs.accessibility}>
        {" "}
        {getTranslatedText(TRANSLATION_CONSTANTS.WEBSITE_ACCESSIBILITY)}
      </a>
    </>
  );

  const getFooterText = (): string => {
    if (hasAllstateBrandFooter && isCanadianFooter) {
      return getTranslatedText(TRANSLATION_CONSTANTS.ALLSTATE_CANADA_FOOTER_TEXT).replace(
        "{{YEAR}}",
        new Date().getFullYear().toString()
      );
    } else if (hasAllstateBrandFooter) {
      return (
        "© " + new Date().getFullYear().toString() + " " + getTranslatedText(TRANSLATION_CONSTANTS.ALLSTATE_FOOTER_TEXT)
      );
    } else {
      return (
        "© " +
        new Date().getFullYear().toString() +
        " " +
        getTranslatedText(TRANSLATION_CONSTANTS.FOOTER_COMPANY_SIGNATURE_CLUB)
      );
    }
  };

  const imgSrc = hasAllstateBrandFooter ? BlueLogo : SigLogo;
  const altText = hasAllstateBrandFooter
    ? getTranslatedText(TRANSLATION_CONSTANTS.FOOTER_COMPANY_SLOGAN)
    : getTranslatedText(TRANSLATION_CONSTANTS.FOOTER_COMPANY_SIGNATURE_CLUB);

  return (
    <footer className={`footer ${hasAllstateBrandFooter ? "" : "smc u-vr-5-top"}`}>
      {isFooterBrandingEnabled ? <img src={imgSrc} alt={altText} /> : null}
      <p className={hasAllstateBrandFooter ? "" : "u-vr-3-top"}>{getFooterText()}</p>
      <p>
        {!!complianceURLs.terms_and_condition ? (
          <>
            {getTranslatedText(TRANSLATION_CONSTANTS.ALL_RIGHT_RESERVED)}{" "}
            <a className="c-link" href={complianceURLs.terms_and_condition}>
              {getTranslatedText(TRANSLATION_CONSTANTS.TERMS_AND_CONDITIONS)}
            </a>
          </>
        ) : (
          <>{getTranslatedText(TRANSLATION_CONSTANTS.TERMS_AND_CONDITIONS_ALLSTATE_CANADA)}</>
        )}
      </p>
      {links}
    </footer>
  );
};

export default Footer;
